module.exports = __webpack_public_path__ + "static/media/background-playlist-image-2.8ca29f4c.svg";